import {
  Button,
  LoadingSpinner,
  PasswordFormField,
  TextFormField,
} from "@/components/ui";
import { useFormContext } from "react-hook-form";

interface LoginFormProps {
  onSubmit: () => Promise<void>;
  isLoading?: boolean;
}

function LoginForm({ onSubmit, isLoading }: LoginFormProps) {
  const form = useFormContext();

  //arg: data: z.infer<typeof formSchema>

  return (
    <form
      onSubmit={form.handleSubmit(onSubmit)}
      className="mt-8 flex flex-col gap-y-4"
    >
      <TextFormField
        dataTestId="login-email"
        register={form.register("email")}
        label="Email"
      />
      <PasswordFormField
        dataTestId="login-password"
        register={form.register("password")}
        label="Password"
      />
      <div className="text-right">
        <Button
          data-testid="login-submit"
          type="submit"
          variant="foreground"
          className="mt-4 w-full"
        >
          {isLoading ? <LoadingSpinner /> : "Login"}
        </Button>
      </div>
    </form>
  );
}

export { LoginForm };
